import React, { Component } from 'react'
import CommonGridHeader, { CommonDeleteButton, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import { withTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Stack, Tooltip, RadioGroup, FormControlLabel, Radio, IconButton, Typography, Autocomplete, ListItem, ListItemText, TextField, Divider, Paper, Modal } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import RepeatIcon from '@mui/icons-material/Repeat';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import DeleteIcon from '@mui/icons-material/Delete';
import { TemplatePopup } from '../SarasOtherDocNotes/SarasCommonComp';
import { Colors } from '../../../../Styles/Colors';

class DocTestLeft extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Testdata: [],
      isDeleteCliked: false,
      SelectedList: {},
      PatientData: this.props?.PatientData,
      TestTransmitted: false,
      showDataType: "all",
      selectionModel: [],
      selectedRows: [],
      radSelectedRows: [],
      templateList: [],
      selectedTemplateName: null,
      tempType: '',
      deleteTemplateName: null,
      deletePopup: false,
      openPopupAddNew: false,
      templateName: '',
      isEdit: false,
      removeData: false,
    }
  }

  GetIntialData = () => {
    this.GetTestdata()
    this.getTemplateData()
  }

  componentDidUpdate(prevprops) {
    if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.GetTestdata() }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  GetTestdata(FromTemplate = false) {
    try {
      let params = ''
      if (FromTemplate) {
        params = Serviceurls.NEW_BILLING_TEST_TEMP_GET + `?id=${this.state.selectedTemplateName?.id}`
      } else {
        params = Serviceurls.DOC_TEST_GET + `?patient_id=${this.state.PatientData?.patient_id}&appointment_id=${this.state.PatientData?.appointment_id}`
      }
      RestAPIService.getAll(params).
        then((response) => {
          if (response.data.status === "success") {
            let TestList = []
            // response.data.data?.forEach((item) => {
            //   item.display_label = item?.lab_test_names ? item?.lab_test_names :
            //     item?.lab_set_names ? item?.lab_set_names :
            //       item?.special_test_name ? item?.special_test_name :
            //         item?.service_name && item?.service_type ? `${item?.service_type} - ${item?.service_name}` :
            //           item?.package_name ? item?.package_name : "";
            //   item.type = item.transmitted_radiology_id ? "Radiology": "Laboratory";
            //   TestList.push(item)
            // })
            if(FromTemplate){
              this.postTestDatas(response.data.data?.tests || [])
            }else{
            this.setState({
              Testdata: response.data.data,
              TestTransmitted: response.data?.is_transmitted ? response.data?.is_transmitted : false
            })
          }
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  postTestDatas(value) {
    try {
      let states = this.state;

      let labTests = value?.filter(item => item?.test_type === "Laboratory")
        ?.map(item => ({
          grp_id: item?.grp_id ?? null,
          test_id: item?.lab_test_ids ?? item?.test_id ?? null,
          service_code: item?.service_code ?? null,
          service_name: item?.service_name ?? null,
          service_head_id: item?.service_head_id ?? null,
          head_name: item?.service_head_name ?? null,
          head_code: item?.service_head_code ?? null,
          service_details_id: item?.service_details_id ?? null,
          test_name: item?.lab_test_names ?? item?.test_name ?? item?.service_name ?? null,
          service_charge_id: item?.service_charge_id ?? null
        })) || [];

      let radiology_service = value?.filter(item => (item?.test_type !== "Laboratory" && item?.test_type !== "Special Test"))?.map(element => ({
        head_code: element?.service_head_code ?? '',
        head_name: element?.service_head_name ?? '',
        module_type: (element?.test_type).toUpperCase() ?? '',
        service_charge_id: element?.service_charge_id ?? null,
        service_code: element?.service_code ?? null,
        service_details_id: element?.service_details_id ?? null,
        service_head_id: element?.service_head_id ?? null,
        service_name: element?.service_name ?? '',
      })) || [];

      let specialTests = value?.filter(item => item?.test_type === "Special Test")?.map(element => ({
        id: null,
        name: element?.name ?? element?.test_master_name ?? '',
      })) || [];

      let data = {
        "lab_tests": labTests,
        "radiology_service": radiology_service,
        "special_tests": specialTests,
        "appointment_id": states.PatientData?.appointment_id,
        "patient_id": states.PatientData?.patient_id
      };
      RestAPIService.create(data, Serviceurls.DOC_TEST_POST)
        .then(response => {
          if (response?.data?.status === 'success') {
            this.successMessage(response.data.message);
            this.setState({ selectedTemplateName: null, templateName: '' },() => {
              this.GetTestdata();
            })
          } else {
            this.errorMessage(response.data.message);
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message);
          } else {
            this.errorMessage(error.message);
          }
        });

    } catch (error) {
      this.errorMessage(error.message);
    }
  }

  onEditHandler(data) {
    this.props.EditAllergyData(data.row)
  }
  onDeleteHandler(data) {
    try {
      this.setState({
        isDeleteCliked: true,
        SelectedList: data.row,
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  popupClose() {
    this.setState({ isDeleteCliked: false })
  }
  DeleteAllergy() {
    try {
      let data = {
        appointment_id: this.props?.PatientData?.appointment_id,
        tests_id: this.state.SelectedList?.id
      }
      RestAPIService.create(data, Serviceurls.DOC_TEST_GET).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({ isDeleteCliked: false, SelectedList: {} }, () => { this.GetTestdata() })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getTemplateData() {
    try {
      RestAPIService.getAll(Serviceurls.NEW_BILLING_TEST_TEMP_GET + `?patient_id=${this.state.PatientData?.patient_id}&appointment_id=${this.state.PatientData?.appointment_id}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({ templateList: response.data.data })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  postNewTemplateData() {
    try {
      let data = {}
      if(this.state.templateName.trim() === ''){
        this.errorMessage("Please Enter Template Name")
        return;
      }
      if(this.state.Testdata?.length === 0 && this.state.tempType !== 'rename'){
        this.errorMessage("Please add tests to create template")
        return;
      }
      if (this.state.tempType === 'rename') {
        data = {
          id: this.state.selectedTemplateName?.id,
          name: this.state.templateName,
        }
      } else {
        data = {
          appointment_id: this.state.PatientData?.appointment_id,
          patient_id: this.state.PatientData?.patient_id,
          name: this.state.templateName,
          tests: this.state.Testdata?.map(item => ({
            ...item,
            test_id: item?.lab_test_ids ?? item?.test_id ?? null,
            grp_id: item?.lab_set_ids ?? item?.grp_id ?? null,
          })) || []
        }
      }
      RestAPIService.create(data, Serviceurls.NEW_BILLING_TEST_TEMP_GET).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({ openPopupAddNew: false, templateName: '', selectedTemplateName: null }, () => { this.getTemplateData() })
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          }
          else {
            this.errorMessage(error.message)
          }
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  
  deleteTemplateData() {
    let states = this.state;
    try {
      RestAPIService.delete(Serviceurls.NEW_BILLING_TEST_TEMP_GET + `?id=${states?.deleteTemplateName?.id}`).
        then((response) => {
          if (response.data.status === "success") {
            this.successMessage(response.data.message)
            this.setState({
              openPopupAddNew: false,
              deleteTemplateName: {},
              selectedTemplateName: '',
              deletePopup: false,
              removeData: false,
              isEdit: false
            });
            this.getTemplateData();
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  clearCheckList = () => {
    this.setState({
      showDataType: "all",
      selectionModel: [],
      selectedRows: [],
      radSelectedRows: [],
    })
  }

  postTestTransmitData = () => {
    try {
      let testIds = [];
      this.state.Testdata?.forEach(element => {
        testIds?.push(element?.id)
      });
      let data = {
        appointment_id: this.props?.PatientData?.appointment_id,
        patient_id: this.props?.PatientData?.patient_id,
        line_item_ids: this.state.selectedRows, // transmit list of laboratory
        radiology_line_items: this.state.radSelectedRows, // transmit list of radiology
      }
      RestAPIService.create(data, Serviceurls.TEST_TRANSMIT)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.clearCheckList();
            this.GetTestdata()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ postLoading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ postLoading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  

  renderTestTemp = () => {
    const { t } = this.props
    let state = this.state;
    return (
      <Autocomplete
        clearIcon
        size="small"
        disabled={this.props?.isLocked}
        sx={{ width: '16vw', marginRight:'0.5vw', marginTop: '-0.2vw' }}
        options={state.templateList}
        value={state.selectedTemplateName}
        getOptionLabel={(option) => typeof option === 'string' ? option : option?.name}
        onChange={(e, value) => {
          this.setState({
            selectedTemplateName: value,
          }, () => {
            if (value) { this.GetTestdata(true) }
          });
        }}
        renderOption={(props, option) => (
          <li {...props} style={{ padding: '0vh 1.5vh' }}>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
              <ListItemText
                primary={
                  option?.name?.length > 30 ? (
                    <Tooltip title={option.name} placement="top">
                      <div>{option.name.slice(0, 21) + '...'}</div>
                    </Tooltip>
                  ) : (
                    option.name
                  )
                }
              />
              <Tooltip title="Delete Template" placement="top" arrow>
                <IconButton
                  edge="end"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      tempType: 'delete',
                      deleteTemplateName: option,
                      deletePopup: true,
                    })
                  }}
                >
                  <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                </IconButton>
              </Tooltip>
            </ListItem>
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="Select Template Name" />}
        PaperComponent={({ children }) => (
          <Paper sx={{ maxHeight: '25vw', overflow: 'auto' }}>
            {children}
            <Divider />
            <Button
              color="primary"
              fullWidth
              sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
              onMouseDown={(e) => {
                e.preventDefault();
                this.setState({ openPopupAddNew: true, tempType: 'Add' });
              }}
            >
              Add Template
            </Button>
            {state.selectedTemplateName && (
              <Button
                color="primary"
                fullWidth
                sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
                onMouseDown={(e) =>{
                  e.preventDefault();
                  this.setState({
                    openPopupAddNew: true,
                    tempType: 'rename',
                    templateName: state.selectedTemplateName.name,
                  })
                }}
              >
                Rename Template
              </Button>
            )}
          </Paper>
        )}
      />
    )
  }

  printTestData = () => {
    try {
        const BasePath = localGetItem("isNewBilling") === "true" ? Serviceurls.New_DOCTOR_NOTES_PRINT : Serviceurls.DOC_DOCTOR_NOTES_TEST_PRINT
        RestAPIService.getAll( BasePath + `?appointment_id=${this.props?.PatientData?.appointment_id}&patient_id=${this.props?.PatientData?.patient_id}`).
            then((response) => {
                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
    } catch (error) {
        this.errorMessage(error.message)
    }
}

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  handleTableCheckbox = (selectedIds) => {
    let states = this.state;
    let selectedSet = new Set(selectedIds);
    let previousSelection = new Set(this.state.selectionModel); // Previous selected rows
    let updatedSelection = new Set(selectedIds); // New selection

    // Step 1: Identify package IDs for selection
    let packageIdsToSelect = new Set();
    states.Testdata.forEach(row => {
        if (selectedSet.has(row.id) && row.package_id) {
            packageIdsToSelect.add(row.package_id);
        }
    });

    // Step 2: Add all rows belonging to selected package IDs
    states.Testdata.forEach(row => {
        if (packageIdsToSelect.has(row.package_id)) {
            updatedSelection.add(row.id);
        }
    });

    // Step 3: Identify package IDs for deselection
    let deselectedIds = [...previousSelection].filter(id => !selectedSet.has(id)); // Previously selected but now removed
    let packageIdsToDeselect = new Set();

    deselectedIds.forEach(id => {
        let deselectedRow = states.Testdata.find(row => row.id === id);
        if (deselectedRow && deselectedRow.package_id) {
            packageIdsToDeselect.add(deselectedRow.package_id);
        }
    });

    // Step 4: Remove all rows belonging to deselected package IDs
    states.Testdata.forEach(row => {
        if (packageIdsToDeselect.has(row.package_id)) {
            updatedSelection.delete(row.id);
        }
    });

    // Step 5: Categorize selected data into lab and radiology lists
    const filteredData = states.Testdata.reduce(
        (acc, element) => {
            if (updatedSelection.has(element.id)) {
                if (element.type === "Laboratory") {
                    acc.labSelectedList.push(element);
                } else {
                    acc.radSelectedList.push(element);
                }
            }
            return acc;
        },
        { labSelectedList: [], radSelectedList: [] }
    );

    // Step 6: Update state with selected rows
    this.setState({
        selectedRows: filteredData.labSelectedList,
        radSelectedRows: filteredData.radSelectedList,
        selectionModel: [...updatedSelection],
        isCheckClicked: updatedSelection.size > 0,
    });
};


  render() {
    try {
      const { t } = this.props
      const states = this.state;
      // this.state.Testdata?.forEach((element, index) => { element.sno = index + 1 });
      const filteredList = states.Testdata?.reduce((acc, element) => {
        if (element?.type?.toLowerCase() === states.showDataType) {
          acc.push({
            ...element,
            sno: acc.length + 1,
          });
        }
        return acc;
      }, []);

      const columns = [
        {
          field: "display_label", flex: 0.3, headerName: t("Service Description"),
          valueGetter: (params) => {
            return (params?.row?.service_name || params?.row?.package_name || params?.row?.special_test_name || "");
          },
          renderCell: (params) => {
            const value = params?.row?.service_name || params?.row?.package_name || params?.row?.special_test_name || "-";
            return (
              <Box component="div">
                {value.length > 25 ? (
                  <Tooltip placement="top" title={value} arrow>
                    <div>{value.slice(0, 23) + "..."}</div>
                  </Tooltip>
                ) : (
                  value
                )}
                {params?.row?.package_name && (
                  <Typography fontSize=".8vw">
                    {params?.row?.package_name}
                  </Typography>
                )}
              </Box>
            );
          },
        },
        {
          field: "type", flex: 0.25, headerName: t("Module"),
          renderCell: ({ row }) => (<Box component={'div'}>
            {row?.type ? row?.type : "-"}
          </Box>)
        },
        {
          field: "status", flex: 0.2, headerName: t("Status"), headerAlign: "center", align: 'center',
          valueGetter: (params) => {
            if (params?.row?.status) return params.row.status;
            if (params?.row?.is_transmitted) return "Inprogress";
            return "Await to transmit";
          },
          renderCell: (params) => (<Box component={'div'}>
            {params?.row?.status ? params?.row?.status : params?.row?.is_transmitted ? 'Inprogress' : "Await to transmit"}
          </Box>)
        },
        {
          field: "action", flex: 0.15, headerName: t("Action"), headerAlign: "center", align: "center",
          renderCell: (params) => {
            const selectedIds = new Set(this.state.selectionModel || []);
            const list = params?.row?.package_lines?.map((item, index) => `${index + 1}. ${item.service_name}, `)
              
            return (<Box display={"flex"} flexDirection={"row"} alignItems={"center"}>  
              {params?.row?.package_lines?.length > 0 ? <Tooltip title={list} placement='top'><IconButton size="small" sx={{width: '1vw', height: '1vw', marginRight: '1vw'}}><VisibilityIcon color='primary'/></IconButton></Tooltip> : null}
              <CommonDeleteButton size={"1.2vw"}
                disable={this.props?.isLocked || params?.row?.is_transmitted || selectedIds.has(params.row.id)}
                onClick={this.onDeleteHandler.bind(this, params)} />
            </Box>)
          }
        }
      ]

      // if (states.showDataType === "all") {
      //   columns.unshift({
      //     field: "sno", flex: 0.1, headerName: t("S No"), headerAlign: "center", align: 'center',
      //     renderCell: ({ row, api }) => (api.getRowIndex(row.id) + 1)
      //   })
      // }

      return (
        <ShowComponents onIntersection={this.GetIntialData.bind(this)}>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <Box component={'div'} className="eMed_CheckBox_Group">
              {/* <RadioGroup
                value={this.state.showDataType}
                sx={{ display: 'flex', flexDirection: 'row' }}
                onChange={(e) => {
                  this.setState({
                    showDataType: e.target.value,
                    selectionModel: [],
                    selectedRows: [],
                  })
                }}
              >
                <FormControlLabel emed_tid= 'doc_test_radio_all' value={'all'} control={<Radio size='small' />} label="All" />
                <FormControlLabel emed_tid= 'doc_test_radio_lab' value={'laboratory'} control={<Radio size='small' />} label="Laboratory Test" />
                <FormControlLabel emed_tid= 'doc_test_radio_rad' value={'radiology'} control={<Radio size='small' />} label="Radiology Test" />
              </RadioGroup> */}
            {this.renderTestTemp()}
            </Box>
            <Button
              className='Common_Btn_Min_Width'
              onClick={() => this.printTestData()}
            >
              <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
            </Button>
            <Tooltip title={"Transmit"} arrow placement='top'>
              <Button
                // disabled={this.state.TestTransmitted || this.props.isLocked || this.state.Testdata?.length === 0}
                disabled={this.state.Testdata?.every(item => item?.is_transmitted) || this.props.isLocked || this.state.Testdata?.length === 0 || this.state.selectionModel?.length === 0}
                onClick={() => { this.postTestTransmitData() }}
                startIcon={<RepeatIcon />}
                variant='outlined'
                size='small'
                sx={{ marginX: '0.5vw', marginBottom: '0.5vw', textTransform: 'capitalize' }}
              >Transmit</Button>
            </Tooltip>
          </Box>
          <Box height={'20vh'} overflow={'auto'}>
            <DataGrid
              density='compact'
              rows = {states.Testdata}
              columns={columns}
              getRowId={(row) => row['id']} // kindly don't change this! the transmit works based on this ID.
              checkboxSelection
              selectionModel={states.selectionModel}
              onSelectionModelChange={(selectedIds) => this.handleTableCheckbox(selectedIds)}
              headerHeight={40}
              hideFooter={true}
              components={{
                NoRowsOverlay: () => (
                  <Stack className='eMed_DocNotes_nodata'>
                    {t("NoRecordsFound")}
                  </Stack>
                )
              }}
              disableSelectionOnClick
              isRowSelectable={(params) => !(params.row.is_transmitted || params.row.type === 'Special Test')}

            />
          </Box>
          {this.state.openPopupAddNew && <TemplatePopup
            open={this.state.openPopupAddNew}
            onClose={() => this.setState({ openPopupAddNew: false, templateName: "" })}
            templateName={this.state.templateName || ''}
            setTemplateName={(value) => this.setState({ templateName: value })}
            tempType={this.state.tempType}
            onSubmit={this.postNewTemplateData.bind(this)}
            Title={'Test Template'}
          />}
          {this.state.isErrorMsg ?
            <ToastMsg
              severity={'error'}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.successMsg ?
            <ToastMsg
              severity={'success'}
              msg={this.state.successMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.isDeleteCliked ? <DeletePopup
            DeletTitle={`${t("deleteMsg")} ${t("Test")} ${this.state.SelectedList.service_name ? this.state.SelectedList?.service_name : this.state.SelectedList?.special_test_name ? this.state.SelectedList?.special_test_name :
              this.state.SelectedList?.package_name ? this.state.SelectedList?.package_name : this.state.SelectedList?.lab_set_names ?  this.state.SelectedList?.lab_set_names : "-"} ?`}
            deleteAlertPopupClose={this.popupClose.bind(this)}
            removeData={this.DeleteAllergy.bind(this)}
          /> : null}
          {this.state.deletePopup && <DeletePopup
            DeletTitle={`Are you sure you want to delete ${this.state.deleteTemplateName?.name} ?`}
            deleteAlertPopupClose={() => { this.setState({ deletePopup: false, isDeleteCliked: false }) }}
            removeData={this.deleteTemplateData.bind(this)}
            disable={this.state.removeData}
          />}
        </ShowComponents>
      )
    }
    catch (e) {

    }
  }
}
export default withTranslation()(DocTestLeft)